import request from '@/tool/request'
import { encryptData } from './crypto'
import store from '@/store'
import { isEnteredFromInstalledWebApp } from '@/tool/pwaEntry'
import i18n from '@/lang'

/**
 * 获取游戏
 */
export function gamelist() {
  return request({
    url: '/games',
    method: 'get',
    params: encryptData({}),
  })
}

/**
 * 获取礼包信息
 */
export function gamePackagesInfo(obj) {
  return request({
    url: '/activity/packages',
    method: 'get',
    params: encryptData(obj),
  })
}

/**
 * 获取游戏信息
 */
export function gameInfo(obj) {
  return request({
    url: '/game_config',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 根据fpid获取角色信息
 */
export function checkfpid(obj, token) {
  return request({
    url: '/callback/get_role_info',
    method: 'post',
    data: encryptData({
      ...obj,
      from_desktop_app: isEnteredFromInstalledWebApp() ? 1 : 0,
      web_mail_uid: store.state.user.webMailUid || '',
    }),
    headers: {
      token: token,
    },
  })
}

/**
 * 任务奖励信息（Banner 宝箱弹窗）
 */
export function taskInfo(obj) {
  return request({
    url: '/task_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 登录
 */
export function auth_login(obj, noToken) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: encryptData(obj),
    noToken: noToken || false,
  })
}

/**
 * 获取sessoon
 */
export function create_session(obj) {
  return request({
    url: '/auth/create_session',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取sessoon状态
 */
export function get_session_status(obj) {
  return request({
    url: '/auth/get_session_status',
    method: 'post',
    data: encryptData(obj),
  })
}

// paypal创建预订单
export function getpaypalorder(obj) {
  return request({
    url: '/paypal/paypal_order',
    method: 'post',
    data: encryptData(buildOrderPayload(obj)),
  })
}

export function paypal_callback(obj) {
  return request({
    url: '/paypal/paypal_capture',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 创建支付宝或者微信预定单
 */
export function getReservationOrder(obj) {
  return request({
    url: '/provider_order',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * payermax创建预订单
 * @param {Object} obj 请求体
 * @param {Object} [pack] 当前礼包（保留参数兼容；customized_package_name 由 store.app.customizationFlag 决定）
 */
export function getpayermaxOrder(obj) {
  return request({
    url: '/payermax/payermax_order',
    method: 'post',
    data: encryptData(buildOrderPayload(obj)),
  })
}

/**
 * payermax查询订单
 */
export function getpayermaxOrderInfo(obj) {
  return request({
    url: '/payermax/get_order_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * psp分流渠道创建预订单
 */
export function getPspOrder(obj) {
  return request({
    url: '/psp_switch/payment_methods',
    method: 'post',
    data: encryptData(buildOrderPayload(obj)),
  })
}

/**
 * psp分流渠道查询订单
 */
export function getPspOrderInfo(obj) {
  return request({
    url: '/psp_switch/get_order_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * Adyen / Primer 创建预订单
 * @param {Object} obj 请求体；会并入 from_desktop_app：1 从桌面/已安装 Web 应用进入，0 否（与 store.app.fromInstalledWebApp 一致）
 * @param {Object} [pack] 当前礼包（保留参数兼容；customized_package_name 由 store.app.customizationFlag 决定）
 */
export function getorder(obj) {
  return request({
    url: '/callback/payment_methods',
    method: 'post',
    data: encryptData(buildOrderPayload(obj)),
  })
}

function buildOrderPayload(obj) {
  const fromDesktopApp = store.state.app.fromInstalledWebApp ? 1 : 0
  const payload = { ...obj, from_desktop_app: fromDesktopApp }
  if (Number(store.state.app.customizationFlag) === 1) {
    payload.customized_package_name = i18n.t(`confrim.order_pack_title_${store.state.app.gameId}`)
  }
  return payload
}

export function primerUpdate(obj) {
  return request({
    url: '/primer/update_payment',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 去支付
 */
export function adyen_callback(obj) {
  return request({
    url: '/callback/adyen_callback',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 去支付校验
 */
export function adyen_payments_details(obj) {
  return request({
    url: '/callback/adyen_payments_details',
    method: 'post',
    data: encryptData(obj),
  })
}

export function get_order_info(obj) {
  return request({
    url: '/adyen/get_order_info',
    method: 'post',
    data: encryptData(obj),
  })
}

// 查询 primer 卡支付支付失败原因
export function primer_payment_fail(obj) {
  return request({
    url: '/primer/get_order_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取账单凭证
 */
export function getinvoice(obj) {
  return request({
    url: '/callback/send/invoice',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 检查列表次数接口
 */
export function packagesinfo(obj) {
  return request({
    url: '/activity/pay_info',
    method: 'get',
    params: encryptData(obj),
  })
}

/**
 * 检查是否弹出验证码
 */
export function checkCanPay(obj) {
  return request({
    url: '/captcha/check',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取code信息
 */
export function getCodeInfo(obj) {
  return request({
    url: '/code_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 检查列表次数接口
 */
export function upcustomurl(obj) {
  return request({
    url: '/callback/custom_url',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取session和短链
 */
export function getSession(obj) {
  return request({
    url: '/callback/user/get_session',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * session获取用户信息
 */
export function getUserInfoBySession(obj) {
  return request({
    url: '/callback/user/get_session_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取公告信息
 */
export function getAnnouncement(obj) {
  return request({
    url: '/announcement/announcement_list',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 *
 // * @param {*} data
 * @rerisk/generateturns
 */
export function getCaptcha(obj) {
  return request({
    url: '/captcha/get_captcha',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 *
 * @param {*} data
 * @returns
 */
export function verifyCaptcha(obj) {
  return request({
    url: '/captcha/verify',
    method: 'post',
    data: encryptData(obj),
  })
}

//上传商品的风控信息
export function riskProduct(obj) {
  return request({
    url: '/risk/generate',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取礼包信息
 */
export function getScheme(obj) {
  return request({
    url: '/activity/get_scheme',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取税率信息
 */
export function getProductionTax(obj) {
  return request({
    url: '/pay/payment_info',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 检查邮编信息
 */
export function checkPostCode(obj) {
  return request({
    url: '/pay/check_post_code',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 获取税率信息
 */
export function confirmTaxNotice(obj) {
  return request({
    url: '/pay/confirm_tax_notice',
    method: 'post',
    data: encryptData(obj || {}),
  })
}

export function getInvoiceEmail(obj) {
  return request({
    url: '/pay/mail_info',
    method: 'post',
    data: encryptData(obj || {}),
  })
}

/**
 * 获取游戏验证码
 */
export function getGameCaptcha(obj) {
  return request({
    url: '/auth/get_game_captcha',
    method: 'post',
    data: encryptData(obj || {}),
  })
}

export function deleteMailInfo(obj) {
  return request({
    url: '/pay/delete_mail_info',
    method: 'post',
    data: encryptData(obj || {}),
  })
}

export function getFZHomePage(obj) {
  return request({
    url: '/homepage',
    method: 'post',
    data: encryptData(obj || {}),
  })
}

export function getBJHomePage(obj) {
  return request({
    url: '/homepage',
    method: 'post',
    data: encryptData(obj || {}),
    baseURL: process.env.VUE_APP_API_BACKURL,
  })
}

/**
 * 获取角色未读事件（弹屏活动）
 */
export function getUnreadEvent(obj) {
  return request({
    url: '/event/get_unread_event',
    method: 'post',
    data: encryptData(obj),
  })
}

/**
 * 上报事件已读
 */
export function readEvent(obj) {
  return request({
    url: '/event/read_event',
    method: 'post',
    data: encryptData(obj),
  })
}
